(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-b2b-modal]').forEach(function (modal) {
      // Each section wrapper gets an inline `position: relative` + `z-index`
      // from the parallax stacking script (see slide-sections.liquid), which
      // creates a stacking context that traps this fixed-position modal below
      // later sections (testimonials, footer, ...). Move it to the end of
      // <body> so it stacks above everything regardless of section order.
      document.body.appendChild(modal);

      var openers = document.querySelectorAll('[data-b2b-open]');
      var closers = modal.querySelectorAll('[data-b2b-close]');
      var serviceSelect = modal.querySelector('[data-b2b-service-select]');
      var lastFocused = null;

      function open(service) {
        lastFocused = document.activeElement;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        if (service && serviceSelect) {
          Array.from(serviceSelect.options).some(function (option) {
            if (option.value === service) {
              serviceSelect.value = service;
              return true;
            }
            return false;
          });
        }

        var firstField = modal.querySelector('input, select, textarea');
        if (firstField) firstField.focus();
      }

      function close() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (lastFocused) lastFocused.focus();
      }

      openers.forEach(function (opener) {
        opener.addEventListener('click', function () {
          open(opener.dataset.b2bService);
        });
      });

      closers.forEach(function (closer) {
        closer.addEventListener('click', close);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
          close();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('.site-header');
    let lastY = 0;
    let ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          const currentY = window.scrollY;
          if (currentY > lastY && currentY > header.offsetHeight) {
            header.classList.add('site-header--hidden');
          } else {
            header.classList.remove('site-header--hidden');
          }
          lastY = currentY;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-city"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function naturalTop(el) {
      var top = 0, node = el;
      while (node) { top += node.offsetTop; node = node.offsetParent; }
      return top;
    }

    var items = Array.from(
      document.querySelectorAll('.hero-city__content')
    ).map(function (content) {
      var section = content.closest('.shopify-section');
      return { content: content, top: section ? naturalTop(section) : 0 };
    });

    if (!items.length) return;

    var desktopQuery = window.matchMedia('(min-width: 641px)');

    function tick() {
      if (!desktopQuery.matches) {
        // Mobile: sections render in plain document flow, no fade/lift effect.
        items.forEach(function (item) {
          item.content.style.opacity   = '';
          item.content.style.transform = '';
        });
        return;
      }

      var scrollY = window.scrollY;
      var vh = window.innerHeight;
      items.forEach(function (item) {
        var progress = Math.min(1, Math.max(0, (scrollY - item.top) / (vh * 0.38)));
        item.content.style.opacity   = 1 - progress;
        item.content.style.transform = 'translateY(' + (-progress * 80) + 'px)';
      });
    }

    window.addEventListener('scroll', function () {
      requestAnimationFrame(tick);
    }, { passive: true });

    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        var section = item.content.closest('.shopify-section');
        if (section) item.top = naturalTop(section);
      });
      requestAnimationFrame(tick);
    });

    tick();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intro-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var content   = document.querySelector('.intro-hero__content');
    var indicator = document.querySelector('.intro-hero__scroll-indicator');
    var target    = document.getElementById('para-quien');
    if (!content) return;

    var targetTop = 0;
    var desktopQuery = window.matchMedia('(min-width: 641px)');

    function measure() {
      if (target) {
        targetTop = target.getBoundingClientRect().top + window.scrollY;
      }
    }

    function tick() {
      var scrollY = window.scrollY;
      var vh      = window.innerHeight;

      if (desktopQuery.matches) {
        /*
         * The intro section always sits at y=0 (first in the stack).
         * As soon as the user scrolls, we map scrollY directly to a 0→1 progress.
         * Fade completes after scrolling 38% of the viewport height.
         */
        var progress = Math.min(1, scrollY / (vh * 0.38));

        content.style.opacity   = 1 - progress;
        content.style.transform = 'translateY(' + (-progress * 80) + 'px)';
      } else {
        // Mobile: plain document flow, no fade/lift effect.
        content.style.opacity   = '';
        content.style.transform = '';
      }

      if (indicator && target) {
        /* Fade the scroll indicator out over the last 200px before #para-quien reaches the top of the viewport. */
        var fadeDistance     = 200;
        var distanceToTarget = targetTop - scrollY;
        indicator.style.opacity = Math.min(1, Math.max(0, distanceToTarget / fadeDistance));
      }
    }

    measure();

    window.addEventListener('scroll', function () {
      requestAnimationFrame(tick);
    }, { passive: true });

    window.addEventListener('resize', function () {
      measure();
      requestAnimationFrame(tick);
    });

    tick();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["positioning"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var buttons = document.querySelectorAll('.audience-card[data-target]');
    if (!buttons.length) return;

    var groups = {};
    document.querySelectorAll('[data-audience-group]').forEach(function (el) {
      var key = el.getAttribute('data-audience-group');
      (groups[key] = groups[key] || []).push(el);
    });

    function setGroupVisible(key, visible) {
      (groups[key] || []).forEach(function (el) {
        el.style.display = visible ? 'block' : '';
      });
    }

    if (window.Shopify && Shopify.designMode) {
      // Keep every audience-triggered section visible while editing in the theme customizer.
      Object.keys(groups).forEach(function (key) {
        setGroupVisible(key, true);
      });
      return;
    }

    function showGroup(key) {
      Object.keys(groups).forEach(function (otherKey) {
        setGroupVisible(otherKey, otherKey === key);
      });

      buttons.forEach(function (btn) {
        btn.setAttribute('aria-expanded', btn.getAttribute('data-target') === key ? 'true' : 'false');
      });

      var focusTarget = document.getElementById(key);
      if (focusTarget) {
        if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
        focusTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        focusTarget.focus({ preventScroll: true });
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-target');
        if (key) showGroup(key);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-testimonials-slider]').forEach(function (slider) {
      var wrap   = slider.closest('.testimonials__slider-wrap');
      var slides = Array.from(slider.querySelectorAll('[data-testimonials-slide]'));
      var cards  = Array.from(slider.querySelectorAll('.testimonial-card'));
      var prev   = wrap.querySelector('[data-testimonials-prev]');
      var next   = wrap.querySelector('[data-testimonials-next]');
      var dotsEl = wrap.querySelector('[data-testimonials-dots]');
      if (slides.length < 2) return;

      var dotLabelTemplate = dotsEl.dataset.dotLabel || 'Slide __N__';

      // Below the 900px breakpoint, slides collapse to `display: contents` and
      // cards scroll individually (see CSS), so the dots must track each card
      // rather than each 3-card slide, or they'd fall out of sync with the scroll.
      var mobileQuery = window.matchMedia('(max-width: 900px)');

      var dots = [];
      var targets = [];
      var observer = null;
      var activeIndex = 0;

      function setActive(index) {
        activeIndex = index;
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === targets.length - 1;
      }

      function setup() {
        targets = mobileQuery.matches ? cards : slides;

        dotsEl.innerHTML = '';
        dots = targets.map(function (target, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'testimonials__dot';
          dot.setAttribute('aria-label', dotLabelTemplate.replace('__N__', i + 1));
          dot.addEventListener('click', function () {
            target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          });
          dotsEl.appendChild(dot);
          return dot;
        });

        if (observer) observer.disconnect();
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio >= 0.6) {
              setActive(targets.indexOf(entry.target));
            }
          });
        }, { root: slider, threshold: [0, 0.6] });
        targets.forEach(function (target) { observer.observe(target); });

        setActive(0);
      }

      setup();
      mobileQuery.addEventListener('change', setup);

      if (prev) {
        prev.addEventListener('click', function () {
          var target = targets[Math.max(0, activeIndex - 1)];
          if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          var target = targets[Math.min(targets.length - 1, activeIndex + 1)];
          if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
